module.exports = __webpack_public_path__ + "assets/img/smartLeftTitleBg.d0421575.png";